import { render } from "./addedit-auto-reply.vue?vue&type=template&id=1482f902"
import script from "./addedit-auto-reply.vue?vue&type=script&lang=js"
export * from "./addedit-auto-reply.vue?vue&type=script&lang=js"

import "./addedit-auto-reply.vue?vue&type=style&index=0&id=1482f902&lang=css"

import exportComponent from "D:\\Project\\crosstechno\\crm-frontend-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__